import { Box, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { IconEye, IconHeartFilled } from '@tabler/icons-react';

import type { PropertyEngagement } from '../types';

const countFormatter = new Intl.NumberFormat('en-US');

export const PdpEngagement = ({ engagement }: { engagement?: PropertyEngagement | null }) => {
  if (!engagement || (engagement.viewCount == null && engagement.saveCount == null)) return null;
  return (
    <Row
      aria-label="Home activity"
      className="flex-wrap items-center gap-3 text-od-content-secondary"
    >
      {engagement.viewCount != null && (
        <Row className="items-center gap-1.5">
          <IconEye aria-hidden="true" size={12} className="text-od-content-inactive-primary" />
          <Text className="whitespace-nowrap text-body-xs leading-3 tracking-[-0.03em]">
            {countFormatter.format(engagement.viewCount)}{' '}
            {engagement.viewCount === 1 ? 'view' : 'views'}
          </Text>
        </Row>
      )}
      {engagement.viewCount != null && engagement.saveCount != null && (
        <Box aria-hidden="true" className="h-3 w-px bg-od-border-primary" />
      )}
      {engagement.saveCount != null && (
        <Row className="items-center gap-1.5">
          <IconHeartFilled aria-hidden="true" size={12} className="text-[#ff3aac]" />
          <Text className="whitespace-nowrap text-body-xs leading-3 tracking-[-0.03em]">
            {countFormatter.format(engagement.saveCount)}{' '}
            {engagement.saveCount === 1 ? 'save' : 'saves'}
          </Text>
        </Row>
      )}
    </Row>
  );
};
